import  { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { categoriesItem } from "../../config/data";


const ManageSkincare = () => {
  const refStep1 = useRef();
  const refStep2 = useRef();
  const refStep3 = useRef();
  const isInView1 = useInView(refStep1, { once: true, margin: "-100px" });
  const isInView2 = useInView(refStep2, { once: true, margin: "-100px" });
  const isInView3 = useInView(refStep3, { once: true, margin: "-100px" });
  return (
    <div className="relative w-full p-2">
      <div className="flex flex-col items-center w-full">
        <h1 className="text-4xl text-center font-medium bg-gradient-to-r from-[#FC5EB2] to-[#444CE7] mb-1 bg-clip-text text-transparent">
          Manage skincare routine
        </h1>
      </div>
      <motion.div
        ref={refStep1}
        initial={{ opacity: 0, y: 40 }}
        animate={isInView1 ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        className="mb-5 w-[96%] md:w-[60%] mx-auto"
        style={{ willChange: "transform, opacity" }}
      >
        <h2 className="text-[#FC5EB2] opacity-50 font-semibold text-4xl mb-1">
          Step 1
        </h2>
        <p className="text-sm font-medium mb-3">
          Pick the rituals that suit you best.
        </p>
        <div className="relative flex flex-col items-center w-full h-[300px] xs:h-[350px] bg-[#FDEDF6] rounded-2xl">
          <img
            loading="lazy"
            className="relative h-full z-10 object-contain"
            src="/iPhStep1.webp"
            alt="IphLeft"
          />
          <div className="absolute z-30 top-36 left-1/2 -translate-x-[160px] flex w-[270px] rounded-3xl bg-[#FC5EB2] text-white">
            <div className="flex flex-col items-start gap-1 py-1 px-3">
              <h3 className="font-semibold text-md">Daily skin care</h3>
              <p className="font-light text-xs w-[190px]">
                Perform rituals daily and complete tasks to earn Beauty stars
                and get top positions on the leaderboard.
              </p>
              <img
                loading="lazy"
                className="object-contain w-8 h-8"
                src="/btnArrow.svg"
                alt="IphLeft"
              />
            </div>
            <img
              loading="lazy"
              className="relative h-[120px] top-[16px] right-[19px] rounded-br-3xl"
              src="/girlStep1l.webp"
              alt="IphLeft"
            />
          </div>
          <div className="absolute top-2 left-1/2 translate-x-[-90px] flex flex-col z-20 w-[250px] rounded-3xl bg-[#444CE7] text-white">
            <div className="flex flex-col gap-1 pt-1 px-3">
              <h3 className="font-semibold text-md">Daily hair care</h3>
              <p className="font-light text-xs">
                Nourish and strengthen your hair step by step with a
                personalized ritual that brings lasting shine, softness, and
                healthy growth.
              </p>
            </div>
            <div className="flex items-start justify-between w-full pl-3">

              <img
                loading="lazy"
                className="w-8 h-8 mb-auto"
                src="/btnArrow.svg"
                alt="IphLeft"
              />


              <img
                loading="lazy"
                className="h-[90px] mb-auto rounded-br-3xl"
                src="/girlStep1r.webp"
                alt="IphLeft"
              />
            </div>
          </div>
        </div>
      </motion.div>
      <motion.div
        ref={refStep2}
        initial={{ opacity: 0, y: 40 }}
        animate={isInView2 ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        className="mb-5 w-[96%] md:w-[60%] mx-auto"
        style={{ willChange: "transform, opacity" }}
      >
        <h2 className="text-[#FC5EB2] opacity-50 font-semibold text-4xl mb-1">
          Step 2
        </h2>
        <p className="text-sm font-medium mb-3">Choose the types of rituals.</p>
        <div className="relative flex flex-col items-center w-full h-[300px] xs:h-[350px] bg-[#F4E9FA] rounded-2xl">
          <img
            loading="lazy"
            className="relative h-full z-10 object-contain"
            src="/iPhStep2.webp"
            alt="IphLeft"
          />
          <div className="w-[350px] flex justify-center absolute bottom-[70px] z-10">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={3} // расстояние между слайдами
              slidesPerView={2.8} // дефолт для мобилок
              centeredSlides={true}
              slidesOffsetBefore={50} // отступ слева
              slidesOffsetAfter={20}
              loop={false}
              autoplay={{ delay: 4000 }}
              className="relative h-full"
            >
              {categoriesItem.map((item, idx) => (
                <SwiperSlide key={idx} className="!w-auto">
                  <div className="flex w-28 justify-center items-center py-2 bg-white rounded-full shadow gap-2">
                    <img
                      loading="lazy"
                      src={item.img}
                      alt={item.title}
                      className="w-6 h-6 object-contain"
                    />
                    <p className="text-xs font-normal">{item.title}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </motion.div>
      <motion.div
        ref={refStep3}
        initial={{ opacity: 0, y: 40 }}
        animate={isInView3 ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        className="mb-5 w-[96%] md:w-[60%] mx-auto"
        style={{ willChange: "transform, opacity" }}
      >
        <h2 className="text-[#FC5EB2] opacity-50 font-semibold text-4xl mb-1">
          Step 3
        </h2>
        <p className="text-sm font-medium mb-3">
          Build your personal ritual schedule.
        </p>
        <div className="relative flex flex-col items-center w-full h-[300px] xs:h-[350px] bg-[#FDEDF6] rounded-2xl">
          <img
            loading="lazy"
            className="relative h-full translate-x-[10%] z-10 object-contain"
            src="/iPhStep3.webp"
            alt="IphLeft"
          />
        </div>
      </motion.div>
    </div>
  );
};
export default ManageSkincare;
